import { createStore } from 'vuex'

export default createStore({
  state: {
    isProgress: false,
    login: true
  },
  mutations: {
    SHOW_PROGRESS (state) {
      state.isProgress = true
    },
    HIDE_PROGRESS (state) {
      state.isProgress = false
    },
    SHOW_LOGIN (state) {
      state.login = true
    },
    HIDE_LOGIN (state) {
      state.login = false
    }
  },
  actions: {
    showProgress ({ commit }) {
      commit('SHOW_PROGRESS')
    },
    hideProgress ({ commit }) {
      commit('HIDE_PROGRESS')
    },
    showLogin ({ commit }) {
      commit('SHOW_LOGIN')
    },
    hideLogin ({ commit }) {
      commit('HIDE_LOGIN')
    }
  },
  modules: {}
})
